import React from 'react';
import { TaskTypeProps } from './../types';
import { Grid, Paper } from '@mui/material';
import Question from '../../QuestionAndAnswer/Question';
import TaskFeedback from '../../Feedback/TaskFeedback';

const QuestionAndAnswers: React.FC<TaskTypeProps> = (props) => {
    return (
        <div className="question-and-answer">
            <Grid container>
                <Grid item xs={12}>
                    <Paper className="question-and-answer-paper" elevation={2}>
                        <Question
                            key={props.task.id}
                            id={props.task.id}
                            feedbackVisible={true}
                            language={props.language}
                            languages={props.languages}
                            skills={props.skills}
                            tasks={props.tasks}
                            setTasks={props.setTasks}
                        ></Question>
                        <Grid item xs={12} style={{ marginTop: 12 }}>
                            <TaskFeedback
                                language={props.language}
                                languages={props.languages}
                                task={props.task}
                                tasks={props.tasks}
                                setTasks={props.setTasks}
                            />
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
};

export default QuestionAndAnswers;
